import React from 'react';
import { Container, Typography, Box } from '@mui/material';
import { useParams } from 'react-router-dom';

const ServiceDetail = () => {
  const { id } = useParams();

  return (
    <Container maxWidth="lg" sx={{ py: 4 }}>
      <Box>
        <Typography variant="h4" gutterBottom>
          Detalle del Servicio
        </Typography>
        <Typography variant="body1">
          Mostrando detalles del servicio con ID: {id}
        </Typography>
      </Box>
    </Container>
  );
};

export default ServiceDetail;